
import { Component, Prop, Watch, BaseMixins, $util, arrayHelper, TabRoute } from "@/lib";

import SideMenu from "./component/side-menu/index.vue";
import HeaderBar from "./component/header-bar/index.vue";
import TagsNav from "./component/tags-nav/index.vue";
import User from "./component/user/index.vue";
import Fullscreen from "./component/fullscreen/index.vue";
import Language from "./component/language/index.vue";
import ABackTop from "./component/a-back-top/index.vue";

import { routers } from "@/router/router";
import minLogo from "@/assets/img/logo-min.jpg";
import maxLogo from "@/assets/img/logo.jpg";
import defaultUserAvator from "@/assets/img/usericon.jpg";
import "./main.less";

import { menuRouteHelper } from "@/lib/utils";
import appConfig from "@/config";

// import copyfooter from '../../../components/Footer.vue'
// import LanguageList from '../../../components/language-list.vue'

@Component({
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    Fullscreen,
    User,
    ABackTop,
  },
})
export default class Main extends BaseMixins {
  name: string = "Main";
  collapsed: boolean = false;
  minLogo: any = minLogo;
  maxLogo: any = maxLogo;
  isFullscreen: boolean = false;
  // useI18n: boolean = appConfig.useI18n;
  isEnableLanguageSwitch = appConfig.isEnableLanguageSwitch;
  enableTabNavigate: boolean = appConfig.enableTabNavigate;
  // annotate refs type.
  // The symbol `!` (definite assignment assertion)
  // is needed to get rid of compilation error.
  $refs!: {
    sideMenu: SideMenu;
  };

  // get tagNavList () {
  //     return this.$store.state.app.tagNavList
  // }
  get tagRouter() {
    return this.$store.state.app.tagRouter;
  }
  get userAvatar() {
    if (this.currentUser && this.currentUser.avatar) {
      return this.currentUser.avatar;
    }
    return defaultUserAvator;
  }
  get cacheList() {
    const list = ["ParentView", ...(this.tagNavList.length ? this.tagNavList.filter((item) => !(item.meta && item.meta.notCache)).map((item) => item.name) : [])];
    return list;
  }

  get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
  get userName() {
    if (this.currentUser) return this.currentUser.name;
    return "未登录";
  }
  get totalUnReadNotification() {
    if (this.currentUser) return this.currentUser.totalUnReadNotification;
    return 0;
  }

  get menuList() {
    let menus: any[] = menuRouteHelper.getMenuByRouterForCurrentUser(routers, this.$store.state.currentUser.permissionList);

    let result = [];
    menus.forEach((el) => {
      if (el.children && el.children.length > 0) {
        let item = Object.assign({}, el);
        item.children = [];
        el.children.forEach((sec) => {
          let secondItem = Object.assign({}, sec);

          if (secondItem.meta && secondItem.meta.access && secondItem.meta.access.length > 0) {
            item.children.push(secondItem);
          } else if (sec.children && sec.children.length > 0) {
            secondItem.children = sec.children.filter((item) => item.meta.access && item.meta.access.length > 0);
            if (secondItem.children.length > 0) {
              item.children.push(secondItem);
            }
          }
        });
        if (item.children.length > 0) {
          result.push(item);
        }
      }
    });

    return result;
  }
  get local() {
    return this.$store.state.app.local;
  }
  // get hasReadErrorPage () {
  //     return this.$store.state.app.hasReadErrorPage
  // },

  setBreadCrumb(route: any) {
    this.$store.commit("app/setBreadCrumb", route);
  }

  setTagNavList(list?: Array<any>) {
    this.$store.commit("app/setTagNavList", list);
  }

  addTag({ route, type = "unshift" }) {
    this.$store.commit("app/addNewTag", { route, type });
  }

  async setLocal(lang: any) {
    await this.$store.dispatch({ type: "system/user/changeLanguage", data: { languageName: lang } });
    window.basic.utils.setCookieValue("Localization.CultureName", lang, new Date(new Date().getTime() + 5 * 365 * 86400000), window.basic.appPath);
    location.reload();
  }

  setHomeRoute(routes: Array<any>) {
    this.$store.commit("app/setHomeRoute", routes);
  }

  closeTag(route: any) {
    this.$store.commit("app/closeTag", route);
  }

  turnToPage(route: string | TabRoute) {
    // let { name, params, query } = {};
    let name: string = "";
    let params, query;

    if (typeof route === "string") {
      name = route;
      if(this.cacheList.includes(name)){
              params = { actionCode:"reset" };
            }
    } else {
      // if(route instanceof TabRoute){

      // }
      let tabRoute = route as TabRoute;
      name = tabRoute.currentRoute.name;
      //如果有默认子路由，则加载默认子路由页面。
      if (tabRoute.currentRoute.meta && tabRoute.currentRoute.meta.defaultChild) {
        name = tabRoute.currentRoute.meta.defaultChild;
      }
      params = tabRoute.currentRoute.params;
      query = tabRoute.currentRoute.query;
      // name = tabRoute.name;
      // //如果有默认子路由，则加载默认子路由页面。
      // if(route.meta && route.meta.defaultChild){
      //     name=route.meta.defaultChild;
      // }
      // params = route.params;
      // query = route.query;
    }

    if (name.indexOf("isTurnByHref_") > -1) {
      window.open(name.split("_")[1]);
      return;
    }
    let newRoute = {
      name,
      params,
      query,
    };

    //Only do the routing for different route.
    if (!menuRouteHelper.routeEqual(this.$route, newRoute)) {
      this.$router.push(newRoute).catch((err) => {
        console.log(err);
      });
    }
  }
  handleCollapsedChange(state: boolean) {
    this.collapsed = state;
  }

  handleCloseTag(res, type, route) {
    if (type !== "others") {
      if (type === "all") {
        this.turnToPage(appConfig.homeName);
      } else {
        let currentTabRoute = menuRouteHelper.getMenuRoute(this.$route);
        if (menuRouteHelper.routeEqual(currentTabRoute, route)) {
          this.closeTag(route);
        }
      }
    }
    this.setTagNavList(res);
  }
  handleClick(item: TabRoute) {
    this.turnToPage(item);
  }

  @Watch("$route")
  routeChange(newRoute: any) {
    // //非标签路由过滤
    let tabRoute = menuRouteHelper.getMenuRoute(newRoute);

    // let tagRoute = new TabRoute();
    //  tagRoute.menuRoute= menuRouteHelper.copyRoute(tabRoute);
    //  tagRoute.name= tabRoute.name;
    //  tagRoute.currentRoute= menuRouteHelper.copyRoute(newRoute);
    //  tagRoute.history.push(menuRouteHelper.copyRoute(newRoute));

    this.addTag({
      route: newRoute,
      type: "push",
    });
    this.setBreadCrumb(newRoute);
    //this.setTagNavList(menuRouteHelper.getNewTagList(this.tagNavList, tagRoute));
    this.$refs.sideMenu.updateOpenName(tabRoute.name);
  }

  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    this.setHomeRoute(routers);

    //    //非标签路由过滤
    // let tabRoute = menuRouteHelper.getMenuRoute(this.$route);
    // let tagRoute = new TabRoute();
    // //tagRoute.menuRoute=Object.assign({},tabRoute);
    // tagRoute.menuRoute= menuRouteHelper.copyRoute(tabRoute);
    // tagRoute.name= tabRoute.name;
    // tagRoute.currentRoute= menuRouteHelper.copyRoute(this.$route);
    // tagRoute.history.push(menuRouteHelper.copyRoute(this.$route));
    //const { name, params, query, meta } = tabRoute;
    this.addTag({
      route: this.$route,
    });
    this.setBreadCrumb(this.$route);
    // 设置初始语言
    // this.setLocal(this.$i18n.locale);
    // 如果当前打开页面不在标签栏中，跳到homeName页
    // if (!this.tagNavList.find(item => item.name === tabRoute.name)) {
    //     this.$router.push({
    //         name: appConfig.homeName
    //     });
    // }
    // TODO：获取未读消息条数
    //this.getUnreadMessageCount();
        this.$store.dispatch("system/customersystemcode/getcustomersystemCode");
          this.$store.dispatch("system/customer/getCustomerList");
           this.$store.dispatch("system/sender/getSenderList");
  }

  get activeName() {
    if (this.$route.meta.hideInMenu) {
      let parentRoute = this.$route.matched[this.$route.matched.length - 2];
      return parentRoute.meta.defaultChild;
    }
    return this.$route.name;
  }
}
